import * as React from "react";
import * as v from "valibot";
import { isEqual } from "lodash";
import { FormattedMessage } from "react-intl";
import { useValibotForm } from "@/utils/validation";
import {
  Form,
  FormField,
  FormControl,
  FormLabel,
  FormItem,
  FormMessage,
} from "@/kit/ui/form";
import { Input } from "@/kit/ui/input";
import { vEmptyToUndefined, vDateFormatOptions } from "./utils";
import { useStateContext } from "../state";
import { DateFormatOptions } from "./DateFormatOptions";

const dirReaderOptionsSchemaFactory = () =>
  v.object({
    glob: v.string(),
    file_key: v.optional(v.pipe(v.string(), v.trim(), vEmptyToUndefined)),
    path_key: v.optional(v.pipe(v.string(), v.trim(), vEmptyToUndefined)),
    date: vDateFormatOptions(),
  });

export const DirReaderOptions = () => {
  const { dirReaderOptions, setDirReaderOptions } = useStateContext();
  const dirReaderOptionsSchema = React.useMemo(
    () => dirReaderOptionsSchemaFactory(),
    [],
  );
  const form = useValibotForm(dirReaderOptionsSchema, {
    defaultValues: dirReaderOptions,
    reValidateMode: "onChange",
  });
  const value = form.watch();
  React.useEffect(() => {
    const { success, output } = v.safeParse(dirReaderOptionsSchema, value);
    if (success) {
      const newDirReaderOptions = {
        ...dirReaderOptions,
        ...output,
      };
      if (!isEqual(newDirReaderOptions, dirReaderOptions)) {
        setDirReaderOptions(newDirReaderOptions);
      }
    }
  }, [value, dirReaderOptionsSchema, dirReaderOptions, setDirReaderOptions]);
  return (
    <Form form={form} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <h2 className="col-span-1 sm:col-span-2 text-l font-semibold">
        <FormattedMessage defaultMessage="Directory Reader Options" />
      </h2>
      <FormField
        control={form.control}
        name="glob"
        render={({ field }) => (
          <FormItem className="col-span-1 sm:col-span-2">
            <FormLabel>
              <FormattedMessage defaultMessage="File glob" />
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="file_key"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="File contents column" />
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="path_key"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="File path column" />
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <DateFormatOptions />
    </Form>
  );
};
